/** OneLink template URL for Smart Script attribution. */
export const APPSFLYER_ONE_LINK_URL = 'https://uvotv.onelink.me/TBbX'

/** CDN URL for OneLink Smart Script (loaded from public/appsflyer-smart-script-init.js). */
export const APPSFLYER_SMART_SCRIPT_SRC =
  'https://onelinksmartscript.appsflyersdk.com/onelink-smart-script-latest.js'

/** AppsFlyer Web SDK base URL (loaded from public/appsflyer-init.js). */
export const APPSFLYER_WEB_SDK_SRC = 'https://websdk.appsflyersdk.com'

/** af_sub1 values — identifies click source for AppsFlyer attribution. */
export const APPSFLYER_AF_SUB1 = {
  topBanner: 'top_banner',
  fullScreenBanner: 'full_screen_banner',
  playerBanner: 'player_banner',
  storeButton: 'store_button',
  emailVerified: 'email_verified',
  popupConfirm: 'global_popup_confirm',
} as const

/**
 * Smart Script attribution parameters for OneLink URL generation.
 * Keep in sync with apps/uvo/public/appsflyer-smart-script-init.js
 */
export const APPSFLYER_PARAMETERS = {
  mediaSource: {
    keys: [
      'utm_source',
      'utm_campaign',
      'utm_medium',
      'utm_content',
      'utm_term',
      'gclid',
    ],
    defaultValue: 'direct',
  },
  campaign: { keys: ['utm_campaign'], defaultValue: 'direct' },
  channel: { keys: ['utm_medium'] },
  ad: { keys: ['utm_content'] },
  adSet: { keys: ['utm_term'] },
  afSub2: { defaultValue: 'livetv' },
  afCustom: [
    { paramKey: 'af_c_id', keys: ['campaignid'] },
    { paramKey: 'af_ss_ui', defaultValue: 'true' },
  ],
} as const

/** Maps backend platform keys to AppsFlyer generateDirectClickURL platform values. */
export const APPSFLYER_PLATFORM_BY_BACKEND_KEY: Record<string, string> = {
  ios: 'ios',
  tvOs: 'ios',
  android: 'android',
  fireTv: 'android',
  roku: 'roku',
  samsung: 'tizen',
  lg: 'webos',
}

/** Amazon Appstore ASIN for Fire / Amazon deep links (af_dp). */
export const AMAZON_APP_ASIN = 'B0CWJCF998'
export const FIRE_TV_PLATFORM_KEY = 'fireTv'
/** Amazon Appstore URI scheme — opens the store app on Fire devices. */
export const AMAZON_AF_DP = `amzn://apps/android?asin=${AMAZON_APP_ASIN}`

/** Attribution params for generateDirectClickURL (install banners omit afSub2). */
export const APPSFLYER_DIRECT_CLICK_PARAMETERS = {
  mediaSource: APPSFLYER_PARAMETERS.mediaSource,
  campaign: APPSFLYER_PARAMETERS.campaign,
  channel: APPSFLYER_PARAMETERS.channel,
  ad: APPSFLYER_PARAMETERS.ad,
  adSet: APPSFLYER_PARAMETERS.adSet,
  afCustom: APPSFLYER_PARAMETERS.afCustom,
} as const
